import { Button, type ButtonProps } from './button'
import LoadingSpinner from './loading-spinner'

export type LoadingButtonProps = ButtonProps & {
  isPending?: boolean
  preserveChildren?: boolean
}

export default function LoadingButton({
  children,
  disabled,
  isPending,
  preserveChildren = true,
  ...props
}: LoadingButtonProps) {
  const isLoading = typeof isPending === 'boolean' ? isPending : disabled

  return (
    <Button disabled={disabled || isLoading} {...props}>
      {isLoading ? (
        <>
          <LoadingSpinner />
          {preserveChildren ? children : null}
        </>
      ) : (
        children
      )}
    </Button>
  )
}
